module.exports = __webpack_public_path__ + "static/media/learning2.db0da02d.png";